import { RowTypes } from '../../enums/pdf-tron/row-types.enum';

export interface AnnualReportExcelRow {
    text?: string | null;
    reference?: string | null;
    closingValue?: number | null;
    closingPercentageValue?: number | null;
    openingValue?: number | null;
    openingPercentageValue?: number | null;
    type: RowTypes;
}
